import { FC } from 'react';
import { SMPContainer } from '../../atoms/SMPContainer';
import { CSS } from '../../../../theme/stitches.config';

interface DropdownListWrapperProps {
  isOpen?: boolean;
  selectedOption?: string;
  children?: React.ReactNode;
  ref?: React.RefObject<HTMLElement>;
  css?: CSS;
}

export const DropdownListWrapper: FC<DropdownListWrapperProps> = ({ isOpen, children, css = {} }) => {
  return (
    <SMPContainer css={{ position: 'relative', margin: 0, padding: 0, ...css }}>
      {isOpen && (
        <SMPContainer
          style={{
            margin: 0,
            padding: 0,
            position: 'absolute',
            backgroundColor: 'var(--colors-multiSportBgColor)',
            borderRadius: '6px',
            border: '1px solid var(--colors-borderMultiSportColor)',
            zIndex: 1000,
          }}
        >
          {children}
        </SMPContainer>
      )}
    </SMPContainer>
  );
};
